var vueDatePickTexts = {
    "months": {
        "de": ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
        "fr": ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre'],
        "it": ['Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre']
    },
    "weekdays": {
        "de": ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
        "fr": ['lun', 'mar', 'mer', 'jeu', 'ven', 'sam', 'dim'],
        "it": ['lun', 'mar', 'mer', 'gio', 'ven', 'sab', 'do']
    },
    "nextMonthCaption": {
        "de": "Nächsten Monat",
        "fr": "mois prochain",
        "it": "prossimo mese"
    },
    "prevMonthCaption": {
        "de": "Vorheriger Monat",
        "fr": "mois précédent",
        "it": "mese scorso"
    },
    "setTimeCaption": {
        "de": "Zeit einstellen:",
        "fr": "Régler le temps:",
        "it": "Tempo impostato:"
    }
};